import AssetCreateModal from "./AssetCreateModal";

export default AssetCreateModal;
